import { createSelector } from '@reduxjs/toolkit'

import { buildOptions } from '../../utils/buildOptions'
import { formatTeacherFull } from '../../utils/formatTeacher'
import { WINDOW_CLASS_TYPE_ID } from '../../containers/schedule/utils/lessonHelpers'

const referencesState = (state) => state.references

const selectGroups = (state) => referencesState(state).groups
const selectTeachers = (state) => referencesState(state).teachers
const selectSubjects = (state) => referencesState(state).subjects
const selectClassTypes = (state) => referencesState(state).classTypes
const selectBuildings = (state) => referencesState(state).buildings
const selectBells = (state) => referencesState(state).bells
const selectRooms = (state) => referencesState(state).rooms
const selectEditorRooms = (state) => referencesState(state).editorRooms

const selectEditorClassTypes = createSelector(
    [selectClassTypes],
    (classTypes) => classTypes.filter((classType) => {
        const id = Number(classType.class_type_id)
        const name = String(classType.name || '').toLowerCase()
        return id !== WINDOW_CLASS_TYPE_ID && !name.includes('окно')
    })
)

const selectGroupOptions = createSelector(
    [selectGroups],
    (groups) => buildOptions(
        groups,
        (group) => group?.group_id,
        (group) => group.name || 'Без названия'
    )
)

const selectTeacherOptions = createSelector(
    [selectTeachers],
    (teachers) => buildOptions(
        teachers,
        (teacher) => teacher?.teacher_id,
        (teacher) => formatTeacherFull(teacher)
    )
)

const selectSubjectOptions = createSelector(
    [selectSubjects],
    (subjects) => buildOptions(
        subjects,
        (subject) => subject.subject_id,
        (subject) => subject.name || 'Без названия'
    )
)

const selectClassTypeOptions = createSelector(
    [selectClassTypes],
    (classTypes) => buildOptions(
        classTypes,
        (classType) => classType.class_type_id,
        (classType) => classType.name || 'Без названия'
    )
)

const selectBuildingOptions = createSelector(
    [selectBuildings],
    (buildings) => buildOptions(
        buildings,
        (building) => building.building_id ?? building.id,
        (building) => building.address || building.name || 'Без названия'
    )
)

const selectRoomOptions = createSelector(
    [selectRooms],
    (rooms) => buildOptions(
        rooms,
        (room) => room.room_id ?? room.id ?? room.audience_id,
        (room) => room.name || room.number || room.title || 'Без названия'
    )
)

const selectBellOptions = createSelector(
    [selectBells],
    (bells) => buildOptions(
        bells,
        (bell) => bell?.bell_id,
        (bell) => bell.bell_id || 'Без названия'
    )
)

const selectEditorClassTypeOptions = createSelector(
    [selectEditorClassTypes],
    (classTypes) => buildOptions(
        classTypes,
        (classType) => classType.class_type_id,
        (classType) => classType.name || 'Без названия'
    )
)

const selectEditorRoomOptions = createSelector(
    [selectEditorRooms],
    (rooms) => buildOptions(
        rooms,
        (room) => room.room_id ?? room.id ?? room.audience_id,
        (room) => room.name || room.number || room.title || 'Без названия'
    )
)

export const referencesSelectors = {
    groups: selectGroups,
    teachers: selectTeachers,
    subjects: selectSubjects,
    classTypes: selectClassTypes,
    buildings: selectBuildings,
    bells: selectBells,
    rooms: selectRooms,
    editorRooms: selectEditorRooms,
    isGroupsLoading: (state) => referencesState(state).loading.groups,
    isTeachersLoading: (state) => referencesState(state).loading.teachers,
    isEditorAudienceLoading: (state) => referencesState(state).loading.editorAudience,
    error: (state) => referencesState(state).error,
    groupOptions: selectGroupOptions,
    teacherOptions: selectTeacherOptions,
    subjectOptions: selectSubjectOptions,
    classTypeOptions: selectClassTypeOptions,
    buildingOptions: selectBuildingOptions,
    roomOptions: selectRoomOptions,
    bellOptions: selectBellOptions,
    editorClassTypeOptions: selectEditorClassTypeOptions,
    editorRoomOptions: selectEditorRoomOptions,
}
